import type {FileType} from '@github-ui/use-unified-file-select'
import {PaperclipIcon} from '@primer/octicons-react'
import {ActionBar} from '@primer/react'
import React from 'react'

interface FileUploadToolbarButtonProps {
  acceptedFileTypes?: FileType[]
  onFileSelect: (file: File) => Promise<void>
}

export const FileUploadToolbarButton = ({acceptedFileTypes, onFileSelect}: FileUploadToolbarButtonProps) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null)

  const handleFileUploadClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.currentTarget.files
    if (files) {
      for (const file of files) {
        try {
          await onFileSelect(file)
        } catch {
          // Silently handle upload errors
        }
      }
    }
    // Reset the input so the same file can be selected again
    if (event.currentTarget) {
      event.currentTarget.value = ''
    }
  }

  return (
    <>
      <ActionBar.IconButton
        variant="invisible"
        icon={PaperclipIcon}
        aria-label="Upload file"
        onClick={handleFileUploadClick}
        data-testid="upload-button"
      />
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept={acceptedFileTypes?.join(',')}
        onChange={handleFileSelect}
        style={{display: 'none'}}
      />
    </>
  )
}
FileUploadToolbarButton.displayName = 'HybridMarkdownEditor.FileUploadToolbarButton'
